export default {"src":"/_next/static/media/heart.0f085496.svg","height":512,"width":592};